/** Пункт головного меню, який відповідає всім довідникам `Setting.List*` */
export const DICTIONARIES_MENU_KEY = 'Setting.Index'

const DICTIONARY_RESOURCE_PREFIX = 'Setting.List'

/**
 * Ключі виділення головного меню з урахуванням довідників: сторінки ресурсів `Setting.List*`
 * (`/settings/cargos`, картка `/settings/cargos/…`) не мають власного пункту, тож для них
 * підсвічується «Довідники». Решта шляхів — як визначило ядро.
 */
export const resolveMenuSelectedKeys = (
    selectedKeys: string[],
    pathname: string,
    resources: Record<string, { pageUrl?: string | undefined }>
): string[] => {
    const isDictionaryPage = Object.entries(resources).some(([key, resource]) => {
        if (!key.startsWith(DICTIONARY_RESOURCE_PREFIX) || !resource.pageUrl) return false
        return pathname === resource.pageUrl || pathname.startsWith(resource.pageUrl + '/')
    })

    return isDictionaryPage ? [DICTIONARIES_MENU_KEY] : selectedKeys
}
